/**
 * Created by Ning Jiang on 2021-09-17.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {GuiButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {KarenLayers, Layers} from "./KarenLayers";
import {KarenReelView} from "../reels/KarenReelView";
import {Karen} from "../Karen";
import {KarenParsedGameData} from "../server/data/KarenParsedGameData";
import {KarenParsedInitData} from "../server/data/KarenParsedInitData";
import {KarenGameConfig} from "../KarenGameConfig";
import {KarenSoundManager} from "../sound/KarenSoundManager";
import {KarenSoundConfig} from "../sound/KarenSoundConfig";
import {PointerState} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/PointerState";
import {SvgLoader} from "@nolimitcity/slot-launcher/bin/loader/SvgLoader";
import {GuiDefaultTextures} from "@nolimitcity/slot-launcher/bin/gui/default/GuiDefaultTextures";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";


export class Reel2Button extends GuiButton {

    private _base: PIXI.Sprite;
    private _signImage: PIXI.Sprite;
    private _layoutIndex: number;
    private _xBet: PIXI.Sprite;


    constructor() {
        super("reel2Button");
        this._base = new PIXI.Sprite(Karen.assetLoader.getTextures("button_inactive")[0]);
        this._xBet = new PIXI.Sprite(Karen.assetLoader.getTextures("bubble")[0]);
        const xBetlogo: PIXI.Sprite = new PIXI.Sprite( SvgLoader.getSvgTexture(Karen.skinner.skinId === "sweep" ? GuiDefaultTextures.X_PLAY : GuiDefaultTextures.X_BET));
        xBetlogo.tint = 0x00000;
        xBetlogo.position.set(39, 25);
        this._xBet.addChild(xBetlogo);
        this._base.anchor.set(0.5, 0.3);
        this._base.alpha = 1;
        this._base.position.set(0, 10);
        this._xBet.position.set(-155, -148);
        this._signImage = new PIXI.Sprite(Karen.assetLoader.getTextures("reel2button/Sign_inactive")[0]);
        this._signImage.anchor.set(0.5, 1);
        this._signImage.alpha = 1;
        this._signImage.position.set(9, 75);
        this._xBet.visible = false;
        this.addChild(this._signImage, this._base, this._xBet);
        this.hitArea = new PIXI.Circle(-5, 25, 25);
    }

    public setIndex(index: number): void {
        this._layoutIndex = index;
        if (this.interactive) {
            this._base.texture = this.getButtonTexture(this._layoutIndex);
        }
    }

    public enable(enable: boolean) {
        super.enable(enable);
        let defDisableIndex: number = this._layoutIndex;
        if (!SlotGame.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
            defDisableIndex = 2;
        }
        this._base.texture = this.getButtonTexture(defDisableIndex);
        this._signImage.texture = this.getSignTexture(defDisableIndex);
    }

    protected onPointerStateUpdate(state: PointerState): void {
        this._xBet.visible = state === 2;
    }

    private getButtonTexture(index: number): PIXI.Texture {
        switch (index) {
            case 0: // off
                return Karen.assetLoader.getTextures("reel2button/Button_off_active")[0];
            case 1: // on
                return Karen.assetLoader.getTextures("reel2button/Button_On_active")[0];
            default: // inactive
                return PIXI.Texture.EMPTY;
        }
    }

    private getSignTexture(index: number): PIXI.Texture {
        switch (index) {
            case 0: // off
                return Karen.assetLoader.getTextures("reel2button/Sign_off_active")[0];
            case 1: // on
                return Karen.assetLoader.getTextures("reel2button/Sign_on_active")[0];
            default: // inactive
                return Karen.assetLoader.getTextures("restricted_enhanced_bet")[0];
        }
    }
}


export class Reel2Frame extends PIXI.Container {

    private _layoutIndex: number;
    private _layoutIndexBeforeFS: number;
    private _button: Reel2Button;
    private _boostedName: string = "BOOSTED_BET";
    private _boostedData: any;
    private _data: KarenParsedGameData | KarenParsedInitData;

    private _isFreeBet: boolean = false;
    private _isFreeFeatureBet: boolean = false;

    constructor() {
        super();

        SlotGame.apiPlugin.freeBets.events.on(SlotGame.apiPlugin.freeBets.FREE_BETS_START, () => this.onFreeBets(true));
        SlotGame.apiPlugin.freeBets.events.on(SlotGame.apiPlugin.freeBets.FREE_BETS_END, () => this.onFreeBets(false));
        SlotGame.apiPlugin.freeFeatureBet.events.on(SlotGame.apiPlugin.freeFeatureBet.FREE_FEATURE_BET_START, () => this.onFreeFeatureBets(true));
        SlotGame.apiPlugin.freeFeatureBet.events.on(SlotGame.apiPlugin.freeFeatureBet.FREE_FEATURE_BET_END, () => this.onFreeFeatureBets(false));

        this._button = new Reel2Button();
        this._button.y = 15;
        this._button.addClickCallback(() => {
            this.updateLayout(this._layoutIndex === 0 ? 1 : 0, true);
        });
        this.addChild(this._button);
        KarenLayers.getLayer(Layers.ENHANCED_BUTTON)?.addChild(this);
        this.setPosition(KarenReelView.REEL_AREAS[1].x, KarenReelView.REEL_AREAS[1].y - 80);
        KarenLayers.getLayer(Layers.FOREGROUND)?.addChild(this);

        const featureData = SlotGame.apiPlugin.bonusFeatures.getFeatureDataByName(this._boostedName);
        if (featureData) {
            this._boostedData = {featureName: this._boostedName, price: featureData.price};
        }

        // get the init data for updateLayout.
        const initData = Karen.model.parsedInitData;
        const mode = initData.mode;
        if (mode === GameMode.NORMAL) {
            // there is no replay starts in fs modes
            if (SlotGame.apiPlugin.options.replay && initData.replayNextPlayerInteraction) {
                const replayData: any = initData.replayNextPlayerInteraction;
                if (replayData && replayData.featureName && replayData.featureName === this._boostedName) {
                    this.updateLayout(1);
                    this.enabled(false);
                    if (!SlotGame.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                        this.updateLayout(2);
                    }
                    return;
                }
            }
            this.updateLayout(0);
            if (!SlotGame.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                this.updateLayout(2);
            }
            return;
        }
        this.updateLayout(2);
        if (SlotGame.apiPlugin.freeBets.hasFreeBets()) {
            this._isFreeBet = true;
        }

        if (SlotGame.apiPlugin.isReplay) {
            this.enabled(false);
        }
    }

    public enabled(value: boolean) {
        if (SlotGame.apiPlugin.isReplay) {
            value = false;
        }
        if (KarenGameConfig.IS_FEATURE_BUY) {
            this._button.visible = false;
            this.updateLayout(2);
        }
        if (this._layoutIndex === 2) {
            return;
        }

        this._button.enable(value);
    }

    public setPosition(x: number, y: number): void {
        this.position.set(x, y);
    }

    public updateMode(mode: string): void {
        if (mode.includes(GameMode.NORMAL)) {
            Karen.background.hideBillBoard();
            KarenGameConfig.IS_FEATURE_BUY = false;
            this._button.visible = true;
            if (!SlotGame.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
                this._layoutIndexBeforeFS = 2;
            }
        }
        if (Karen.model.isRestore) {
            this._data = Karen.model.parsedInitData;
            if (this._data.boostedBetPlayed) {
                this._layoutIndexBeforeFS = 1;
            } else {
                this._layoutIndexBeforeFS = 0;
            }
        } else {
            this._data = Karen.model.parsedGameData;
        }
        this.updateLayout(this._layoutIndexBeforeFS != null ? this._layoutIndexBeforeFS : 0);
        if (!mode.includes(GameMode.NORMAL)) {
            if (this._data.wasFeatureBuy) {
                this.updateLayout(2);
            } else {
                this._button.enable(false);
            }
            this._button.visible = false;
            Karen.background.enableBillBoard();
        }
    }

    private onFreeBets(value: boolean): void {
        this.updateLayout(0);
        this._isFreeBet = value;
        if (value) {
            Karen.background.hideBillBoard();
        }
        if (!SlotGame.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
            this.updateLayout(2);
        }
    }

    private onFreeFeatureBets(value: boolean): void {
        this.updateLayout(0);
        this._isFreeFeatureBet = value;
        if (value) {
            Karen.background.hideBillBoard();
        }
        if (!SlotGame.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
            this.updateLayout(2);
        }
    }

    // 0-off 1-on 2-hide in fs.
    public updateLayout(index: number, isClicked: boolean = false): void {
        if (this._isFreeBet) {
            this._layoutIndexBeforeFS = 0;
            Karen.background.hideBillBoard();
            return;
        } else if (this._isFreeFeatureBet) {
            this._layoutIndexBeforeFS = 0;
            return;
        }

        if (this._layoutIndex === index) {
            return;
        }

        if (index != 2) {
            this._layoutIndexBeforeFS = index;
        }
        this._layoutIndex = index;

        if (index === 2) {
            this._button.enable(false);
            this._layoutIndexBeforeFS = 0;
            return;
        }

        this._button.setIndex(this._layoutIndex);
        this._button.enable(!Karen.autoPlayPlugin.isAutoplayRound);
        this._button.visible = true;
        let soundName: string = KarenSoundConfig.ENHANCED_BET_OFF;
        if (index === 1) {
            soundName = KarenSoundConfig.ENHANCED_BET_ON;
            Karen.apiPlugin.betFeatureController.setActiveBetFeature("BOOSTED_BET");
        } else {
            let featureData: BetFeature | undefined = Karen.apiPlugin.betFeatureController.getActiveBetFeature();
            if (featureData) {
                Karen.apiPlugin.betFeatureController.setActiveBetFeature(featureData?.name);
            } else {
                SlotGame.apiPlugin.betHandler.setBoost(undefined);
            }
        }
        if (isClicked) {
            KarenSoundManager.playSoundEffect(soundName);
        }
    }
}
